import React from "react";
import PropTypes from "prop-types";
import "../App.css";
import { config } from "../config";

const steps = ["Flights Selected", "Details", "Summary", "Confirmation"];

function ProgressBar({ currentStep }) {
  return (
    <div className="overflow-x-auto py-6 border-b mb-6">
      <div className="flex justify-between items-center space-x-4">
        {steps.map((step, index) => (
          <div key={index} className="flex items-center">
            <div
              className={`w-6 h-6 flex items-center justify-center rounded-full ${
                index < currentStep
                  ? "bg-green-500"
                  : index === currentStep
                  ? `bg-${config.primaryColor}`
                  : "bg-gray-300"
              } text-white`}
            >
              {index < currentStep ? "✓" : index + 1}
            </div>
            <span className="ml-2 text-sm text-gray-600 whitespace-nowrap">{step}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
};

export default ProgressBar;
